import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Courses from "./pages/Courses";
import Contact from "./pages/Contact";
import PolicyPage from "./pages/PolicyPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import Header from "./components/Header";
import Footer from "./components/Footer";
import BookTrialBanner from "./components/BookTrialBanner";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";
import { SiteContentProvider } from "./lib/SiteContentContext";
import { DEFAULT_TITLE } from "./lib/usePageTitle";

// Route → browser-tab title. Keeps titles consistent and easy to maintain
// centrally; each pathname falls back to the site-wide default.
const PAGE_TITLES = {
  "/":              DEFAULT_TITLE,
  "/about":         "About Science Sorted",
  "/services":      "How We Teach | Science Sorted",
  "/courses":       "Science Courses | Science Sorted",
  "/contact":       "Contact Science Sorted",
  "/privacy":       "Privacy Policy | Science Sorted",
  "/terms":         "Terms & Conditions | Science Sorted",
  "/cookies":       "Cookie Policy | Science Sorted",
  "/safeguarding":  "Safeguarding | Science Sorted",
  "/refunds":       "Cancellation Policy | Science Sorted",
  "/admin/login":   "Admin Login | Science Sorted",
};

function DocumentTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const base = pathname.startsWith("/admin")
      ? "Admin | Science Sorted"
      : PAGE_TITLES[pathname] || DEFAULT_TITLE;
    document.title = base;
  }, [pathname]);
  return null;
}

function PublicChrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) return children;
  return (
    <>
      <Header />
      <div id="main">{children}</div>
      <Footer />
      <BookTrialBanner />
      <div aria-hidden="true" className="h-24 md:h-24" />
    </>
  );
}

function App() {
  return (
    <div className="App bg-white min-h-screen">
      <SiteContentProvider>
        <BrowserRouter>
          <ScrollToTop />
          <DocumentTitle />
          <a
            href="#main"
            className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-brand-ink focus:text-brand-sun focus:px-4 focus:py-2 focus:rounded-full"
          >
            Skip to content
          </a>
          <PublicChrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<PolicyPage slug="privacy" />} />
              <Route path="/terms" element={<PolicyPage slug="terms" />} />
              <Route path="/cookies" element={<PolicyPage slug="cookies" />} />
              <Route path="/safeguarding" element={<PolicyPage slug="safeguarding" />} />
              <Route path="/refunds" element={<PolicyPage slug="refunds" />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/*" element={<AdminDashboard />} />
            </Routes>
          </PublicChrome>
          <Toaster />
        </BrowserRouter>
      </SiteContentProvider>
    </div>
  );
}

export default App;
